import { render, staticRenderFns } from "./DetailsNew.vue?vue&type=template&id=655c87f4&scoped=true"
import script from "./DetailsNew.vue?vue&type=script&lang=ts"
export * from "./DetailsNew.vue?vue&type=script&lang=ts"
import style0 from "./DetailsNew.vue?vue&type=style&index=0&id=655c87f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c87f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655c87f4')) {
      api.createRecord('655c87f4', component.options)
    } else {
      api.reload('655c87f4', component.options)
    }
    module.hot.accept("./DetailsNew.vue?vue&type=template&id=655c87f4&scoped=true", function () {
      api.rerender('655c87f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/DetailsNew.vue"
export default component.exports